/* wn-home: home page + collection behaviour (agent C). Self-contained; no dependency on wn.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var hasIO = 'IntersectionObserver' in window;

  /* header height for the sticky collection toolbar */
  function headH() {
    var h = $('[data-head]') || $('.head') || $('header');
    if (h) document.documentElement.style.setProperty('--wn-head-h', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  headH(); addEventListener('resize', headH, { passive: true });

  /* ---------- countdowns: data-hm-cd="week|midnight|rolling:45|date:2026-10-31T23:59" ---------- */
  function cdTarget(mode) {
    var now = Date.now(), d = new Date();
    mode = mode || 'week';
    if (mode.indexOf('rolling:') === 0) {
      var mins = parseFloat(mode.split(':')[1]) || 45, len = mins * 60000, key = 'hm_cd_' + mins, start = 0;
      try { start = +localStorage.getItem(key) || 0; if (!start) { start = now; localStorage.setItem(key, start); } } catch (e) { start = now - (now % len); }
      return start + Math.ceil((now - start + 1) / len) * len;
    }
    if (mode.indexOf('date:') === 0) return new Date(mode.slice(5)).getTime();
    if (mode === 'midnight') { d.setHours(24, 0, 0, 0); return d.getTime(); }
    d.setDate(d.getDate() + ((7 - d.getDay()) % 7)); d.setHours(24, 0, 0, 0); return d.getTime();
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    $$('[data-hm-cd]').forEach(function (el) {
      var s = Math.max(0, Math.floor((cdTarget(el.getAttribute('data-hm-cd')) - Date.now()) / 1000));
      var D = Math.floor(s / 86400), H = Math.floor((s % 86400) / 3600), M = Math.floor((s % 3600) / 60), S = s % 60;
      el.textContent = D ? D + 'd ' + H + 'h ' + pad(M) + 'm ' + pad(S) + 's' : H ? H + 'h ' + pad(M) + 'm ' + pad(S) + 's' : M + 'm ' + pad(S) + 's';
    });
  }
  if ($('[data-hm-cd]')) { tick(); setInterval(tick, 1000); }

  /* ---------- lazy / eager background videos ---------- */
  var mobile = false;
  try { mobile = matchMedia('(max-width: 749px)').matches; } catch (e) {}
  function startVid(v) {
    if (v.dataset.hmOn) return;
    var src = (mobile && v.dataset.hmSrcM) || v.dataset.hmSrc;
    if (!src) return;
    v.dataset.hmOn = '1';
    v.src = src;
    v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function initVids(root) {
    if (reduce) return;
    var vids = $$('video[data-hm-src]', root);
    if (!hasIO) { vids.forEach(startVid); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { startVid(v); if (v.paused && v.dataset.hmOn) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (v.dataset.hmOn && !v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) {
      if (v.hasAttribute('data-hm-eager')) {
        var go = function () { startVid(v); };
        if (document.readyState === 'complete') setTimeout(go, 50); else addEventListener('load', go, { once: true });
      }
      io.observe(v);
    });
  }
  initVids(document);

  /* ---------- tabs ---------- */
  $$('[data-hm-tabs]').forEach(function (sec) {
    var tabs = $$('[role="tab"]', sec);
    function sel(t) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (k) { e.preventDefault(); var n = tabs[(i + k + tabs.length) % tabs.length]; sel(n); n.focus(); }
      });
    });
  });

  /* ---------- rails ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hm-rail]'); if (!b) return;
    var r = document.getElementById(b.getAttribute('aria-controls')); if (!r) return;
    var c = r.firstElementChild, w = c ? c.getBoundingClientRect().width + 12 : 300;
    r.scrollBy({ left: +b.dataset.hmRail * w * (innerWidth > 900 ? 2 : 1), behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- lens demo ---------- */
  $$('[data-hm-lens]').forEach(function (el) {
    var input = $('input', el);
    var set = function (v) { el.style.setProperty('--cut', v + '%'); };
    input.addEventListener('input', function () { set(input.value); });
    if (reduce || !hasIO) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = null;
      (function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / 1800), v = 96 - 58 * (1 - Math.pow(1 - k, 3));
        set(v); input.value = Math.round(v);
        if (k < 1) requestAnimationFrame(step);
      })(performance.now());
    }, { threshold: 0.5 });
    io.observe(el);
  });

  /* ---------- cart helper (shared contract with agent B) ---------- */
  function addToCart(items) {
    var root = (window.WN && window.WN.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong. Try again.'); return j; }); })
      .then(function (j) { document.dispatchEvent(new CustomEvent('wn:cart:refresh', { detail: { open: true } })); return j; });
  }

  /* ---------- spotlight ---------- */
  $$('[data-hm-spot]').forEach(function (sp) {
    var img = $('[data-hm-spot-img]', sp), name = $('[data-hm-spot-name]', sp), low = $('[data-hm-spot-low]', sp);
    var add = $('[data-hm-spot-add]', sp), err = $('[data-hm-spot-err]', sp);
    $$('.hm-dot', sp).forEach(function (d) {
      d.addEventListener('click', function () {
        $$('.hm-dot', sp).forEach(function (x) { x.setAttribute('aria-checked', x === d); });
        if (img && d.dataset.src && img.getAttribute('src') !== d.dataset.src) {
          img.classList.add('is-swap');
          var pre = new Image(); pre.onload = function () { img.srcset = d.dataset.srcset || ''; img.src = d.dataset.src; img.classList.remove('is-swap'); }; pre.src = d.dataset.src;
        }
        if (name) name.textContent = d.dataset.name;
        if (low) low.hidden = !d.dataset.low || d.dataset.avail !== 'true';
        if (add) { var ok = d.dataset.avail === 'true'; add.dataset.id = d.dataset.id; add.disabled = !ok; add.textContent = ok ? 'Add to cart' : 'Sold out'; }
        if (err) err.hidden = true;
      });
    });
    add && add.addEventListener('click', function () {
      add.classList.add('is-busy'); if (err) err.hidden = true;
      addToCart([{ id: +add.dataset.id, quantity: 1 }])
        .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
        .then(function () { add.classList.remove('is-busy'); });
    });
  });

  /* ---------- 3-for-2 nudge: fills as frames land in the bag (reads WNCart.state().frames) ---------- */
  var NUDGE = [null,
    ['1 in your bag.', 'Add 2 more, the 3rd is free.'],
    ['2 in your bag.', 'Add 1 more frame, it’s free.'],
    ['3rd pair free, unlocked.', 'Applied at checkout.']];
  function nudge(st) {
    var els = $$('[data-hm-nudge]'); if (!els.length) return;
    if (!st) { try { st = window.WNCart && window.WNCart.state && window.WNCart.state(); } catch (e) {} }
    var n = st && st.frames ? +st.frames : 0, k = n >= 3 ? 3 : n;
    els.forEach(function (el) {
      var t = $('[data-hm-nudge-t]', el); if (!t) return;
      if (!el._hm0) el._hm0 = t.innerHTML;
      if (String(k) === el.dataset.k) return;
      el.dataset.k = k;
      if (!k) { t.innerHTML = el._hm0; return; }
      t.textContent = ''; var b = document.createElement('b'); b.textContent = NUDGE[k][0];
      t.appendChild(b); t.appendChild(document.createTextNode(' ' + NUDGE[k][1]));
    });
  }
  document.addEventListener('wn:cart:updated', function (e) { nudge(e.detail); });
  if (document.readyState === 'complete') setTimeout(nudge, 400); else addEventListener('load', function () { setTimeout(nudge, 400); }, { once: true });

  /* ---------- collection ---------- */
  $$('[data-cl]').forEach(function (cl) {
    var sid = cl.dataset.section;
    var sort = $('[data-cl-sort]', cl);
    /* keep the current quick link in view in the scrolling pill row */
    var pills = $('.cl-pills', cl), cur = pills && $('[aria-current]', pills);
    if (cur && pills.scrollWidth > pills.clientWidth) pills.scrollLeft = Math.max(0, cur.offsetLeft - pills.offsetLeft - 24);
    sort && sort.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
    });

    /* filter drawer */
    var drawer = $('[data-cl-drawer]', cl), scrim = $('.cl-scrim', cl), opener = $('[data-cl-filter-open]', cl), lastFocus = null;
    function openF() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-on'); scrim.classList.add('is-on'); });
      opener && opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var f = $('.cl-x', drawer); f && f.focus(); }, 60);
    }
    function closeF() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-on'); scrim.classList.remove('is-on');
      opener && opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 350);
      lastFocus && lastFocus.focus && lastFocus.focus();
    }
    opener && opener.addEventListener('click', openF);
    $$('[data-cl-filter-close]', cl).forEach(function (b) { b.addEventListener('click', closeF); });
    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') closeF();
      if (e.key === 'Tab') {
        var f = $$('a[href],button:not([disabled]),input:not([disabled]),select', drawer); if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    var form = $('[data-cl-form]', cl);
    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form), u = new URL(form.action, location.origin);
      fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
      location.href = u.toString();
    });

    /* no dead cells: hold back the cards that would leave a ragged last row while more pages exist;
       on the last page, close the row with a 3-for-2 filler tile instead */
    var grid = $('[data-cl-items]', cl), held = [], tpl = $('template[data-cl-fill]', cl);
    function fill() {
      if (!grid) return;
      held.forEach(function (c) { grid.appendChild(c); }); held = [];
      $$('.cl-fill', grid).forEach(function (f) { f.remove(); });
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      var cells = 0;
      Array.prototype.forEach.call(grid.children, function (c) { if (c.hasAttribute('data-cl-full')) { cells = Math.ceil(cells / cols) * cols; return; } cells += c.classList.contains('cl-promo') ? Math.min(2, cols) : 1; }); /* lx: full-width rows reset the count (agent H) */
      var r = cells % cols; if (!r) return;
      if ($('[data-cl-more]', cl)) {
        var cards = Array.prototype.filter.call(grid.children, function (c) { return !c.classList.contains('cl-promo') && !c.hasAttribute('data-cl-full'); });
        if (cards.length > r + 4) held = cards.slice(-r);
        held.forEach(function (c) { c.remove(); });
      } else if (tpl && cols > 1) {
        var f = tpl.content.firstElementChild.cloneNode(true);
        f.style.gridColumn = 'span ' + (cols - r);
        if (cols - r === 1) f.classList.add('is-1');
        grid.appendChild(f);
      }
    }
    fill();
    var fcols = 0;
    addEventListener('resize', function () { var n = grid ? getComputedStyle(grid).gridTemplateColumns.split(' ').length : 0; if (n !== fcols) { fcols = n; fill(); } }, { passive: true });

    /* load more */
    cl.addEventListener('click', function (e) {
      var more = e.target.closest('[data-cl-more]'); if (!more) return;
      e.preventDefault();
      more.classList.add('is-busy'); more.setAttribute('aria-busy', 'true');
      var u = new URL(more.href, location.origin); u.searchParams.set('section_id', sid);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $('[data-cl-items]', doc), grid = $('[data-cl-items]', cl);
        if (items && grid) {
          var first = null;
          held.forEach(function (c) { if (!first) first = c; grid.appendChild(c); }); held = [];
          Array.prototype.slice.call(items.children).forEach(function (c) { if (!first) first = c; grid.appendChild(c); });
          initVids(grid);
          document.dispatchEvent(new CustomEvent('wn:cards', { detail: grid }));
          var fl = first && $('a', first); if (fl) fl.focus({ preventScroll: true });
        }
        var shown = $('[data-cl-shown]', doc); if (shown) $('[data-cl-shown]', cl).textContent = shown.textContent;
        var meter = $('[data-cl-meter]', doc); if (meter) $('[data-cl-meter]', cl).style.width = meter.style.width;
        var next = $('[data-cl-more]', doc);
        if (next) { more.href = next.getAttribute('href'); more.classList.remove('is-busy'); more.removeAttribute('aria-busy'); }
        else more.remove();
        fill();
      }).catch(function () { location.href = more.href; });
    });
  });
})();
